import { PER_PAGE_TYPES } from "enums";
import { ItemSearchOptions } from "models";
import React from "react";
import { Utils } from "utils";

type PROPS = {
  options: ItemSearchOptions;
  onSearch?: () => void;
};

/** 商品一覧の検索条件 */
const ItemListSearchOptionsArea: React.FC<PROPS> = (props) => {
  const [keyword, setKeyword] = React.useState("");
  const [priceFrom, setPriceFrom] = React.useState("");
  const [priceTo, setPriceTo] = React.useState("");
  const [isNegative, setisNegative] = React.useState(true);
  const [isIMEModing, setIsIMEModing] = React.useState(false);
  const onReset = () => {
    for (let k in props.options) {
      delete (props.options as any)[k];
    }
    props.options.get_count = PER_PAGE_TYPES.DEFAULT;
    if (props.onSearch) {
      props.onSearch();
    }
  };

  const onSearch = () => {
    if (props.onSearch) {
      props.onSearch();
    }
  };
  const onCompositionStart = () => {
    setIsIMEModing(true);
  };
  const onCompositionEnd = () => {
    setIsIMEModing(false);
  };

  const handlePaste = (
    e: React.ClipboardEvent<HTMLInputElement>,
    setValue: (value: string) => void
  ) => {
    e.preventDefault();

    const pastedData = e.clipboardData.getData("text");
    const numericValue = pastedData.replace(/[^\d.-]/g, "");

    let [integerPart, ...decimalParts] = numericValue.split(".");
    integerPart = integerPart.slice(0, 11);
    const truncatedInteger = integerPart.slice(0, 10);
    const parsedValue =
      decimalParts.length > 0
        ? `${truncatedInteger}.${decimalParts[0].slice(0, 2)}`
        : truncatedInteger;

    const numericParsedValue = parseFloat(parsedValue);

    if (
      !isNaN(numericParsedValue) &&
      numericParsedValue <= 9999999999.99 &&
      numericParsedValue >= -9999999999.99
    ) {
      const formattedValue = Utils.formatNumericInput(parsedValue);
      if (setValue == setPriceFrom) {
        props.options.price_from = parseFloat(formattedValue.replace(/,/g, ""));
        setValue(formattedValue);
      }
      if (setValue == setPriceTo) {
        props.options.price_to = parseFloat(formattedValue.replace(/,/g, ""));
        setValue(formattedValue);
      }
    } else {
      console.log(
        "Invalid value. It must be between -9999999999.99 and 9999999999.99"
      );
    }
  };
  React.useEffect(() => {
    if (props.options.keyword) {
      setKeyword(props.options.keyword);
    } else {
      setKeyword("");
    }
    if (props.options.price_from) {
      setPriceFrom(props.options.price_from.toString());
    } else {
      setPriceFrom("");
    }
    if (props.options.price_to) {
      setPriceTo(props.options.price_to.toString());
    } else {
      setPriceTo("");
    }
  }, [props.options.keyword, props.options.price_from, props.options.price_to]);

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        onSearch();
      }}
      className="border-y p-4 threadAdminSearch"
    >
      <div className="flex items-start gap-4">
        <div className="flex-1 flex items-center flex-wrap gap-x-2">
          <span>キーワード</span>
          <input
            className="flex-1"
            value={keyword}
            onChange={(e) => {
              const value = e.target.value;
              setKeyword(value);
              if (value) {
                props.options.keyword = value;
              } else {
                delete props.options.keyword;
              }
            }}
          />
        </div>
        <div className="flex items-center flex-wrap gap-x-2">
          <span>価格</span>
          <div className="flex items-center gap-2">
            <input
              step={1}
              className="w-full"
              value={Utils.formatNumericInput(priceFrom)}
              type="tel"
              onCompositionStart={onCompositionStart}
              onCompositionEnd={onCompositionEnd}
              onKeyUp={(e) => {
                const inputElement = e.target as any;
                const inputValue = inputElement.value;
                console.log('inputValue',inputValue)
                if (isIMEModing) {
                    const formattedValue = Utils.formatNumericInput(inputValue);
                    console.log('formattedValueisIMEModing',formattedValue)
                    setPriceFrom(formattedValue);
                } else {
                  const numericValue = inputValue.replace(/[^\d.-]/g, "");
                  console.log('numericValue',numericValue)
                  const formattedNumericValue = Utils.formatNumericInput(numericValue);
                  console.log("formattedNumericValue", formattedNumericValue);
                  setPriceFrom(formattedNumericValue);
                }
              }}
              onPaste={(e) => handlePaste(e, setPriceFrom)}
              onChange={(e) => {
                const inputElement = e.target as HTMLInputElement;
                let numericValue = inputElement.value;
                const tmp = parseFloat(numericValue.replace(/,/g, ""));
                if (tmp > 9999999999.99 || tmp < -9999999999.99) {
                  return;
                }
                props.options.price_from = parseFloat(numericValue.replace(/,/g, ""));
                setPriceFrom(numericValue);
              }}
              onBlur={(e) => {
                const rawValue = (e.target as any).value;
                console.log("rawValue", rawValue);
                const sanitizedValue = Utils.formatNumericBlur(rawValue);
                setPriceFrom(sanitizedValue);
              }}
            />
            <span className="">円</span>
            <span className="">&nbsp;〜&nbsp;</span>
            <input
              step={1}
              className="w-full"
              value={Utils.formatNumericInput(priceTo)}
              type="tel"
              onCompositionStart={onCompositionStart}
              onCompositionEnd={onCompositionEnd}
              onKeyUp={(e) => {
                const inputElement = e.target as any;
                const inputValue = inputElement.value;
                console.log('inputValue',inputValue)
                if (isIMEModing) {
                    const formattedValue = Utils.formatNumericInput(inputValue);
                    console.log('formattedValueisIMEModing',formattedValue)
                    setPriceTo(formattedValue);
                } else {
                  const numericValue = inputValue.replace(/[^\d.-]/g, "");
                  console.log('numericValue',numericValue)
                  const formattedNumericValue = Utils.formatNumericInput(numericValue);
                  console.log("formattedNumericValue", formattedNumericValue);
                  setPriceTo(formattedNumericValue);
                }
              }}
              onPaste={(e) => handlePaste(e, setPriceTo)}
              onChange={(e) => {
                const inputElement = e.target as HTMLInputElement;
                let numericValue = inputElement.value;
                const tmp = parseFloat(numericValue.replace(/,/g, ""));
                if (tmp > 9999999999.99 || tmp < -9999999999.99) {
                  return;
                }
                props.options.price_to = parseFloat(numericValue.replace(/,/g, ""));
                setPriceTo(numericValue);
              }}
              onBlur={(e) => {
                const rawValue = (e.target as any).value;
                console.log("rawValue", rawValue);
                const sanitizedValue = Utils.formatNumericBlur(rawValue);
                setPriceTo(sanitizedValue);
              }}
            />
            <span className="">円</span>
          </div>
        </div>
      </div>
      <div className="mt-4 flex justify-end gap-4">
        <div className="mt-2 underline cursor-pointer" onClick={onReset}>
          検索条件を解除
        </div>
        <button type="submit" className="primary px-8 py-2" onClick={onSearch}>
          検索
        </button>
      </div>
    </form>
  );
};

export default ItemListSearchOptionsArea;
